import { jsx as B } from "react/jsx-runtime";
import { forwardRef as C } from "react";
import N from "@mui/material/TextField";
import V from "styled-components";
import "../LabelTooltip/LabelTooltip.js";
import j from "../LabelTooltip/utils.js";
import { isTextType as I, addClearTextAdornment as W } from "./ClearText/ClearText.js";
import q from "./utils/calculateInputPadding.js";
const G = {
  root: "textFieldRoot"
}, J = {
  classes: {
    root: "labelRoot",
    focused: "labelFocused",
    shrink: "labelShrink",
    asterisk: "labelAsterisk",
    disabled: "labelDisabled",
    outlined: "labelOutlined",
    error: "labelError"
  }
}, K = {
  classes: {
    input: "inputInput",
    focused: "inputFocused",
    disabled: "inputDisabled",
    multiline: "inputMultiline",
    error: "inputError"
  }
}, Q = {
  classes: {
    root: "outlinedInputRoot",
    input: "outlinedInput",
    focused: "inputFocused",
    notchedOutline: "inputNotchedOutline",
    multiline: "inputMultiline",
    error: "outlinedInputError",
    disabled: "outlinedInputDisabled",
    adornedEnd: "outlinedInputAdornedEnd",
    inputAdornedEnd: "outlinedInputInputAdornedEnd"
  }
}, U = {
  classes: {
    root: "formHelperTextRoot",
    error: "formHelperTextError",
    disabled: "formHelperTextDisabled",
    contained: "formHelperTextContained"
  }
}, g = {
  filled: "filled",
  outlined: "outlined",
  standard: "standard"
}, X = V(N).withConfig({
  displayName: "StyledTextField"
})([
  "&.textFieldRoot{min-width:30px;}&& .labelRoot{position:relative;font-weight:",
  ";color:",
  ";line-height:18px;margin:0px 0px 8px 0px;transform:none;pointer-events:auto;}&& .labelRoot .labelAsterisk{color:",
  ";}&& .labelRoot.labelError{color:",
  ";}&&& .outlinedInputRoot{color:",
  ";background-color:",
  ";border:1px solid ",
  ";padding:0px;}&&& .outlinedInputRoot .outlinedInput:first-of-type{min-height:",
  ";height:",
  ";line-height:1.2em;padding:",
  ";border-radius:inherit;box-sizing:border-box;}&&& .outlinedInputRoot.inputMultiline{padding:2px 0px;}&&& .outlinedInputRoot.inputMultiline .outlinedInput{padding:6px 12px;}&& .outlinedInputRoot fieldset{display:none;}&& .outlinedInputRoot:hover:not(.outlinedInputDisabled):not(.outlinedInputError){border-color:",
  ";}&&& .outlinedInputRoot.inputFocused{outline:",
  ";}&&& .outlinedInputRoot.outlinedInputError:hover{border-color:",
  ";}&& .outlinedInputRoot.outlinedInputError{border-color:",
  ";}&&& .outlinedInputRoot.outlinedInputError.inputFocused{border-color:",
  ";outline-color:",
  ";}&&& .outlinedInputRoot.outlinedInputDisabled{color:",
  ";border-color:",
  ";background-color:",
  ";}&& .outlinedInputRoot .outlinedInput::placeholder{color:",
  ";opacity:1 !important;}&& .outlinedInputRoot button.clearTextButtonIcon{display:none;}&& .outlinedInputRoot.inputFocused:not(.outlinedInputDisabled) button.clearTextButtonIcon,&& .outlinedInputRoot:hover:not(.outlinedInputDisabled) button.clearTextButtonIcon{display:",
  ";}&& .outlinedInputRoot.inputFocused:not(.outlinedInputDisabled),&& .outlinedInputRoot:hover:not(.outlinedInputDisabled){padding-right:",
  ";border-color:",
  ";}& .formHelperTextRoot{width:100%;display:block;position:",
  ";bottom:",
  ";white-space:",
  ";font-size:",
  ";color:",
  ";line-height:",
  ";margin:4px 0px 0px 0px;text-align:",
  ";}& .formHelperTextRoot.formHelperTextError{color:",
  ";text-align:",
  ";}& .formHelperTextRoot.formHelperTextDisabled{color:",
  ";}"
], ({ theme: e }) => e.typography.fontWeightBold, ({ theme: e }) => e.color.text.highemphasis, ({ theme: e }) => e.color.border.error, ({ theme: e }) => e.color.text.highemphasis, ({ theme: e }) => e.color.text.highemphasis, ({ theme: e }) => e.color.background.input, ({ theme: e }) => e.color.border.surface, ({ $size: e }) => e === "medium" ? "40px" : "32px", ({ type: e }) => e === "color" ? "0px" : "auto", ({ type: e, $size: t }) => q({
  type: e,
  $size: t
}), ({ theme: e }) => e.color.border.surfacehover, ({ theme: e }) => `1.5px solid ${e.color.border.surfacehover}`, ({ theme: e }) => e.color.border.error, ({ theme: e }) => e.color.border.error, ({ theme: e }) => e.color.border.error, ({ theme: e }) => e.color.border.error, ({ theme: e }) => e.color.text.disabled, ({ theme: e }) => e.color.border.disabled, ({ theme: e }) => e.color.background.disabled, ({ theme: e }) => e.color.text.lowemphasis, ({ type: e }) => I(e) ? "inherit" : "none", ({ $disableClear: e, type: t }) => !e && I(t) && "26px", ({ theme: e }) => e.color.border.surfacehover, ({ $helperTextOverlay: e }) => e ? "absolute" : "relative", ({ $helperTextOverlay: e }) => e ? "-20px" : "0px", ({ $helperTextOverlay: e }) => e ? "nowrap" : "normal", ({ theme: e }) => e.typography.body100.fontSize, ({ theme: e }) => e.color.text.highemphasis, ({ theme: e }) => e.typography.body100.lineHeight, ({ $helperTextPosition: e }) => e === "left" ? "start" : "end", ({ theme: e }) => e.color.border.error, ({ $errorTextPosition: e }) => e === "left" ? "start" : "end", ({ theme: e }) => e.color.text.disabled), Y = /* @__PURE__ */ C(({ classes: e, defaultValue: t = void 0, disableClear: l = !0, errorTextPosition: R = "right", FormHelperTextProps: T, helperText: u, helperTextPosition: y = "left", helperTextOverlay: v = !1, InputLabelProps: F, InputProps: i, label: a, multiline: p = !1, name: c, onChange: n = void 0, onClear: E = void 0, select: b, SelectProps: r, size: H = "small", value: x, variant: m = "outlined", inputProps: k, type: D = "text", minRows: A = 3, maxRows: w = 5, tooltip: $ = void 0, slotProps: o, ...L }, M) => {
  var h, s;
  const O = a === "" ? " " : a, z = u === "" ? " " : u;
  let f = x;
  x === void 0 && n !== void 0 && t === void 0 && (r == null ? void 0 : r.defaultValue) === void 0 && // @ts-expect-error - defaultValue is not detected.
  ((h = o == null ? void 0 : o.select) == null ? void 0 : h.defaultValue) === void 0 && (f = "");
  let d = (i == null ? void 0 : i.endAdornment) || ((s = o == null ? void 0 : o.input) == null ? void 0 : s.endAdornment);
  return !b && !p && !l && (d = W(c, E || n, d)), /* @__PURE__ */ B(X, {
    $errorTextPosition: R,
    $helperTextPosition: y,
    $helperTextOverlay: v,
    $disableClear: l,
    $size: H,
    multiline: p,
    classes: {
      ...G,
      ...e
    },
    helperText: z,
    slotProps: {
      ...o,
      input: {
        ...m === g.outlined ? Q : K,
        // Support deprecated InputProps
        ...i,
        ...o == null ? void 0 : o.input,
        endAdornment: d
      },
      htmlInput: {
        autoComplete: "off",
        // Support deprecated inputProps
        ...k,
        ...o == null ? void 0 : o.htmlInput
      },
      inputLabel: {
        ...J,
        shrink: m !== g.outlined,
        // Support deprecated InputLabelProps
        ...F,
        ...o == null ? void 0 : o.inputLabel
      },
      formHelperText: {
        ...U,
        // Support deprecated FormHelperTextProps
        ...T,
        ...o == null ? void 0 : o.formHelperText
      },
      select: {
        // Support deprecated SelectProps
        ...r,
        ...o == null ? void 0 : o.select
      }
    },
    label: j(O, $),
    name: c,
    select: b,
    onChange: n,
    defaultValue: t,
    value: f,
    type: D,
    minRows: A,
    maxRows: w,
    ...L,
    ref: M
  });
});
Y.displayName = "TextField";
export {
  Y as default
};
